import { Autocomplete, Chip, TextField } from "@mui/material";

const KeywordsTagInput = ({
    placeholder,
    value = [],
    onChange,
    textFieldProps,
}) => {
    return (
        <Autocomplete
            multiple
            freeSolo
            options={[]} // no predefined options
            value={value}
            onChange={(event, newValue) => {
                onChange(newValue);
            }}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip
                        variant="outlined"
                        label={option}
                        {...getTagProps({ index })}
                        key={index}
                    />
                ))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={placeholder}
                    {...textFieldProps}
                />
            )}
        />
    );
};

export default KeywordsTagInput;